import { EcoFeeModalEnum } from '@inter-ikea-kompis/component-eco-fee';
import {
	ChileSecLinkModalEnum,
	EnergyEfficiencyClassModalEnum,
	EprelLinkModalEnum
} from '@inter-ikea-kompis/component-energy-efficiency-class';
import { LawLabelModalEnum } from '@inter-ikea-kompis/component-law-label';
import { RepairabilityIndexModalEnum } from '@inter-ikea-kompis/component-repairability-index';
import { WaterEfficiencyClassModalEnum } from '@inter-ikea-kompis/component-water-efficiency-class';

enum PriceModuleModalEnum {
	energyLabelCard = EnergyEfficiencyClassModalEnum.energyLabelCard,
	ecoFeeCard = EcoFeeModalEnum.ecoFeeCard,
	energyFicheCard = EprelLinkModalEnum.energyFicheCard,
	energySecCard = ChileSecLinkModalEnum.energySecCard,
	unifiedWaterLabelCard = WaterEfficiencyClassModalEnum.waterLabelCard,
	repairabilityIndexCard = RepairabilityIndexModalEnum.repairabilityIndexCard,
	lawLabelCard = LawLabelModalEnum.lawLabelCard
}

export default PriceModuleModalEnum;
